module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNyAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4yNDI2IDAuMTIxMzJMMjYuNTQ3NCAxMC40MjYxTDI2LjQ3MzQgMTAuNUgyNi41TDE2LjUgMjFIMTJMMjAuNTcxNCAxMkgwVjlIMjAuODc4N0wxMiAwLjEyMTMySDE2LjI0MjZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.svg
// module id = 42
// module chunks = 1